import React from 'react';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import PropTypes from 'prop-types';

const animatedComponents = makeAnimated();

const SelectSelectize = ({
  isMulti,
  hideResetButton,
  isSearchable = true,
  onValuesChange,
  onSearchChange,
  onBlur,
  options,
  renderNoResultsFound,
  values,
  styles,
  className,
  components = null,
  id,
  placeholder,
  inputValue,
  ariaLabelledBy,
  controlShouldRenderValue = true,
}) => (
  <Select
    components={components || animatedComponents}
    className={className}
    styles={styles}
    isMulti={isMulti}
    isClearable={!hideResetButton}
    isSearchable={isSearchable}
    onChange={onValuesChange}
    options={options}
    noOptionsMessage={renderNoResultsFound}
    onInputChange={onSearchChange}
    onBlur={onBlur}
    value={values}
    placeholder={placeholder}
    controlShouldRenderValue={controlShouldRenderValue}
    id={`selectors-selectSelectize-${id}`}
    instanceId={`selectors-selectSelectize-${id}`}
    aria-labelledby={ariaLabelledBy}
    {...(inputValue === undefined ? {} : { inputValue })}
  />
);

SelectSelectize.propTypes = {
  id: PropTypes.string.isRequired,
  isMulti: PropTypes.bool,
  hideResetButton: PropTypes.bool,
  isSearchable: PropTypes.bool,
  onValuesChange: PropTypes.func,
  onSearchChange: PropTypes.func,
  onBlur: PropTypes.func,
  options: PropTypes.array,
  renderNoResultsFound: PropTypes.func,
  values: PropTypes.any,
  styles: PropTypes.object,
  className: PropTypes.string,
  components: PropTypes.object,
  placeholder: PropTypes.string,
  inputValue: PropTypes.string,
  ariaLabelledBy: PropTypes.string,
  controlShouldRenderValue: PropTypes.bool,
};

export default SelectSelectize;
